import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { EnumChatSuggestionsLayout } from '../../enums/chat-suggestions-layout.enum';
import { EnumTopicType, ITopic } from '../../interfaces/topic.interface';

@Component({
  selector: 'sgt-chat-suggestions',
  templateUrl: './chat-suggestions.component.html',
  styleUrls: ['./chat-suggestions.component.scss'],
})
export class ChatSuggestionsComponent implements OnChanges {
  @Input() topics: ITopic[] = [];
  @Input() layout: EnumChatSuggestionsLayout = EnumChatSuggestionsLayout.List;
  @Input() loading = false;
  @Input() skeletonCount = 8;
  @Output() topicSelected = new EventEmitter<ITopic>();

  readonly layouts = EnumChatSuggestionsLayout;
  skeletonItems: ReadonlyArray<number> = [];

  ngOnChanges(): void {
    this.skeletonItems = Array.from({ length: this.skeletonCount }, (_, i) => i);
  }

  onSelect(topic: ITopic): void {
    this.topicSelected.emit(topic);
  }

  isQuickAction(topic: ITopic): boolean {
    return topic.type === EnumTopicType.QuickAction;
  }

  trackBySkeleton(index: number): number {
    return index;
  }

  trackByTopic(_: number, topic: ITopic): string {
    return topic.quickActionId ?? topic.message;
  }
}
